/**
 * @author lst
 * @update 2020-08-13 by Ariel
 */
import React from "react";
import { connect } from "dva";
import moment from "moment";
import ApplyStepsInfoLimit from './applyStepsInfoLimit'
import { utils_tool, component_tool, framework_tool } from "@/tool";
import ApplyPlanDetail from "../applyPlan/applyPlanDetail";
import ApplyAuth from "../applyAuth/applyAuth";
import './applyStep.less'
import { WizBraftEditorPlus } from "@/containers/common";

let { Session } = utils_tool
const {
  WizForm,
  WizButton,
  WizRow,
  WizCol,
  WizCustomSteps,
  WizNotice,
  Wizmessage,
  WizTooltip,
  WizIcon,
  WizRadio,
  WizSpin,
  WizInputNumber
} = component_tool;
let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool;

const steps = [
  {
    title: '报名基本信息',
    content: 'First-content',
  },
  {
    title: '计划安排信息',
    content: 'Second-content',
  },
  {
    title: '报名设置',
    content: 'Last-content',
  },
];
const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/workflow/apply/applyDetailUpd') {
    if (history.location.record) {
      record = history.location.record
      record.channelType = 'update'
      Session.set('applyDetailUpd', record)
    } else {
      record = Session.get('applyDetailUpd') || {}
    }
  }
  if (history.location && history.location.pathname === '/workflow/apply/applyDetailAdd') {
    if (history.location.record) {
      record = history.location.record
      record.channelType = record.channelType || 'create'
      Session.set('applyDetailAdd', record)
    } else {
      record = Session.get('applyDetailAdd')
    }
  }
  return record
}

class ApplySteps extends WizContainer {
  componentName = "applySteps";

  constructor(props) {
    super(props)
    let { history } = props
    let record = getParamRecord(history)
    let planType_=null;
    if (record){
      let { planType } = record;
      if (planType == undefined || planType == null) {
        planType_ = 1
      }else {
        planType_ = planType;
      }
    }
    this.state = {
      planType:planType_,
      current: 0,
      key: 'applyDetail_' + new Date().getTime(),
      id: record.id,
      auditFlag: 0
    }
    this.nextStepState = false
    let { channelType, plans } = record
    this._type = channelType
    this.plans = plans
    this.initialValue = {}//报名初始化值
  }

  //更改报名信息收集类型
  onChangeInfoType = (form, value) => {
    form.setFieldsValue({
      infoType: value
    })
    // this.setState({time: new Date().getTime()})
  }
  //更改报名信息问卷id
  onChangeInfoId = (value) => {
    // this.setState({surveyId: value})
    this.refs.form.setFieldsValue({
      surveyId: value
    })
  }
  _componentDidMount() {
    let { history } = this.props
    let record = getParamRecord(history)
    if (record && record.id) {
      this.doAction({
        path: 'apply/getApplyInfo',
        payload: {
          key: 'applyInfo',
          apiParams: { id: record.id }
        }
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.current = 0;
    if (this.current !== prevState['current']) {
      document.getElementById('apply-step').scrollIntoView(true);
      this.current = prevState['current']
    }
  };

  //监听数据变化
  propsAndStateOnChange = {
    applyInfo: this._applyInfoOver.bind(this),
    addApply: this._stepOne.bind(this),
  }

  _applyInfoOver(nextProps, nextState) {
    let { applyInfo } = nextProps
    if (applyInfo.code === 1) {
      if (applyInfo && applyInfo.success) {
        this.initialValue = applyInfo.data
        if (applyInfo.data && applyInfo.data.surveyId) {
          nextState.surveyId = applyInfo.data.surveyId
          nextState.surveyName = applyInfo.data.surveyName
        }
        if (applyInfo.data && applyInfo.data.planType) {
          nextState.planType = applyInfo.data.planType;
        }
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.activityMessageInfo.msg);
    }
    return true;
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addApply.code == 1) {
      this.initialValue = nextProps.addApply.data
      WizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.sourceId = this.state.id
        nextState.applyId = nextProps.addApply.data.id
      } else {
        this.jumpPage('replace', '/workflow/apply');
      }
    } else {
      this.nextStepState = false;
      WizNotice.error('保存失败：' + nextProps.addApply.msg);
    }
    return true;
  }

  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    let infoVal = this.refs.form.getFieldValue('infoType')
    // let auditVal = this.refs.form.getFieldValue('auditType')

    this.setState({
      infoType: infoVal,
    })
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue, callback) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'applyDate' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD HH:mm:ss")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD HH:mm:ss")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let applyImg = fitterValues['applyImg']
    if (applyImg && applyImg.length) {
      fitterValues['img'] = applyImg[0]['fileId']
      delete fitterValues['applyImg']
    }
    //信息收集校验
    if (fitterValues['infoType'] === 2) {
      if (!fitterValues['surveyId']) {
        Wizmessage.error('问卷收集：请选择问卷!');
        return;
      }
    }
    let dealerLimit = fieldsValue['dealerLimit']
    if (dealerLimit === null || dealerLimit===undefined || dealerLimit===''){
      fitterValues['dealerLimit'] = 0;
    }
    callback && callback(fitterValues)
  }

  /**保存报名信息 */
  _saveApply(values) {
    let apiPath = 'apply/add';
    let { applyId } = this.state
    if (this.state.id || this._sourceId || applyId) {
      apiPath = 'apply/update'
    }
    this.fitterFieldsValue(values, (fitterValues) => {
      this.setState({ planType: fitterValues['planType'] }, () => {
        this.doAction({
          path: apiPath,
          payload: {
            key: 'addApply',
            apiParams: {
              ...fitterValues,
            }
          }
        });
      })
    })
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
            onClick={e => this.nextStep()}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  /**根据步骤展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      let { applyLoading } = this.props
      return (
        <WizSpin spinning={applyLoading}>
          <WizForm key={new Date().getTime()} className='form-inline' {...formProps} />
        </WizSpin>
      )
    } else if (this.state.current == 1) {
      return <ApplyPlanDetail
        applyId={this.state.applyId}
        planType={this.state.planType}
        plans={this.plans}
        type={this._type}
        nextFunc={() => this.setState({ current: this.state.current + 1 })}
        backFunc={() => this.jumpPage('replace', '/workflow/apply')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else if (this.state.current == 2) {
      return <ApplyAuth
        applyId={this.state.applyId}
        planType={this.state.planType}
        type={this._type}
        initialValue={this.initialValue}
        nextFunc={() => this.jumpPage('replace', '/workflow/apply')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else {
      return null;
    }
  }

  _render() {
    let onChangeInfoType = this.onChangeInfoType
    let onChangeInfoId = this.onChangeInfoId
    const { applyLoading } = this.props;
    let { repeatSubmit, allowCancel, enrollWay, intro,planType } = this.initialValue
    if (repeatSubmit == undefined || repeatSubmit == null) {
      repeatSubmit = 1
    }
    if (allowCancel == undefined || allowCancel == null) {
      allowCancel = 1
    }
    if (enrollWay == undefined || enrollWay == null) {
      enrollWay = 1
    }
    if (planType == undefined || planType == null) {
      planType = 1
    }
    const dateFormat = 'YYYY-MM-DD HH:mm'
    let {surveyId,surveyName} = this.state

    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '报名名称',
        name: 'name',
        formItem: {
          maxLength: 40,
          placeholder: '报名名称最多输入40个字',
          rules: [
            {
              required: true,
              message: '请输入报名名称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '报名名称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: '报名时间',
        name: 'applyDate',
        dataIndex: 'applyDate',
        formItem: {
          type: 'date~',
          showTime: true,
          format: 'YYYY-MM-DD HH:mm',
          rules: [
            {
              required: true,
              message: '请选择报名时间',
            }
          ],
          initialValue: this.initialValue.startTime && this.initialValue.endTime ? [moment(this.initialValue.startTime, dateFormat), moment(this.initialValue.endTime, dateFormat)] : null
        },
      },
      {
        title: '上传封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('applyImg', {
                  initialValue: (this.initialValue && this.initialValue.img) ? [
                    { fileId: this.initialValue.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '报名方式',
        name: 'enrollWay',
        dataIndex: 'enrollWay',
        dict: [
          { code: 1, codeName: '学员报名' },
          { code: 0, codeName: '协调员报名' }
        ],
        formItem: {
          type: 'radio',
          initialValue: enrollWay
        }
      },
      {
        title: '报名安排类型',
        name: 'planType',
        dataIndex: 'planType',
        dict: [
          { code: 1, codeName: "班级" },
          { code: 0, codeName: "通用" },
          // {code: 2, codeName: "活动"},
        ],
        formItem: {
          type: 'select',
          initialValue: planType,
          onChange: (form, value, e) => {
            this.setState({planType:value});
          }
        }
      },
      this.state.planType != null && this.state.planType != undefined && this.state.planType === 1 ?
      {
        title: '经销商人数限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol>
                  {
                    getFieldDecorator('dealerLimit', {
                      rules: [
                        { required: true, message: '请输入经销商人数限制', },
                        { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                      ],
                      initialValue: this.initialValue.dealerLimit===null ||  this.initialValue.dealerLimit===undefined ? 0 : this.initialValue.dealerLimit
                    })(
                      <WizInputNumber placeholder={'请输入经销商人数限制'} min={0} max={9999}  precision={0}/>
                    )
                  }
                  <WizTooltip title={'经销商人数限制默认“0”时报名人数为不做限制。'}>
                    <WizIcon type='question-circle-o'/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      } : {},
      {
        title: "审核设置",
        name: "auditType",
        dataIndex: "auditType",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            let auditType = this.initialValue.auditType && this.initialValue.auditType != 0 ? this.initialValue.auditType : 0
            const { getFieldDecorator } = form;
            return (<>
              <WizRow>
                <WizCol>
                  {getFieldDecorator('auditType', {
                    initialValue: auditType
                  })(
                    <WizRadio.Group
                      key={'auditType'}
                      options={[{ label: '自动审核', value: 0 }, { label: '人工审核', value: 1 }]}
                      value={auditType}
                    />)}
                  <WizTooltip title="人工审核：除了基本校验和业务校验之外，需行政人员进行审核。">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            </>
            )
          }
        },
      },
      {
        title: "信息收集",
        name: "infoType",
        dataIndex: "infoType",
        formItem: {
          type: 'diy',
          diy: ApplyStepsInfoLimit,
          rules: [],
          initialValue: this.initialValue.infoType && this.initialValue.infoType != 0 ? this.initialValue.infoType : 0,
          value: this.state.infoType,
          surveyId: surveyId || this.initialValue.surveyId,
          surveyName: surveyName || this.initialValue.surveyName,
          onChange: onChangeInfoType,
          onChangeInfoId: onChangeInfoId
        },
      },
      {
        name: 'surveyId',
        formItem: {
          type: 'hidden',
          initialValue: surveyId == -1 ? null : surveyId
        }
      },
      {
        title: '是否允许重复提交',
        name: 'repeatSubmit',
        dataIndex: 'repeatSubmit',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (<>
              <WizRow>
                <WizCol>
                  {getFieldDecorator('repeatSubmit', {
                    initialValue: repeatSubmit
                  })(
                    <WizRadio.Group
                      key={'auditType'}
                      options={[{ label: '是', value: 1 }, { label: '否', value: 0 }]}
                      value={repeatSubmit}
                    />)}
                  <WizTooltip title="针对审核未通过的报名，设置为“是”允许再次提交；反之不允许。">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            </>
            )
          }
        },
      },
      {
        title: '是否允许取消报名',
        name: 'allowCancel',
        dataIndex: 'allowCancel',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (<>
              <WizRow>
                <WizCol>
                  {getFieldDecorator('allowCancel', {
                    initialValue: allowCancel
                  })(
                    <WizRadio.Group
                      key={'allowCancel'}
                      options={[{ label: '是', value: 1 }, { label: '否', value: 0 }]}
                      value={allowCancel}
                    />)}
                  <WizTooltip title="针对待审核的报名，设置为“是”允许取消报名；反之不允许。">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            </>
            )
          }
        }
      },
      {
        title: '介绍',
        name: 'intro',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('intro', {
                  initialValue: intro && intro,
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} />
                )}
              </>
            )
          }
        },
      },
    ]

    let onSubmit = this._saveApply.bind(this);
    let formProps = {
      ref: 'form',
      loading: applyLoading,
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 }
      }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }
    return <div id='apply-step'>
      <WizCustomSteps {...wizCustomStepsProps} />
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { apply } = state;
  const applyInfo = modelUtils.getModelEntity(apply, 'applyInfo');
  const addApply = modelUtils.getModelEntity(apply, 'addApply');
  const load = modelUtils.getLoadingState(state, ['apply']);
  return {
    applyInfo,
    addApply,
    ...load
  }
};

export default connect(mapStateToProps)(ApplySteps);
